import ApiClient from '../ApiClient';

class CrmPipelinesAPI extends ApiClient {
  constructor() {
    super('crm/pipelines', { accountScoped: true });
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/stages`, data);
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, data);
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  reorderStages(pipelineId, ids) {
    return axios.post(`${this.url}/${pipelineId}/stages/reorder`, { ids });
  }

  aiSuggest(data) {
    return axios.post(`${this.url}/ai_suggest`, data);
  }

  reorderPipelines(pipelines) {
    return axios.post(`${this.url}/reorder`, { pipelines });
  }
}

export default new CrmPipelinesAPI();
